function getIsDeployed () {
  return process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test';
}

module.exports = getIsDeployed;
